import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d33cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-center-edit-list__name" }
const _hoisted_2 = {
  key: 0,
  style: {"flex-shrink":"0","display":"flex","align-items":"center"}
}
const _hoisted_3 = { class: "project-center-edit-list__index" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "project-center-edit-list__line" }, null, -1))
const _hoisted_5 = {
  key: 1,
  style: {"flex-shrink":"0","display":"flex","align-items":"center"}
}
const _hoisted_6 = { class: "project-center-edit-list__scene" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "project-center-edit-list__arrow" }, null, -1))
const _hoisted_8 = { style: {"display":"flex","align-items":"center","flex":"1"} }
const _hoisted_9 = {
  key: 0,
  style: {"flex-shrink":"0"}
}

import { withDefaults } from 'vue';
import { CopyDocument } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import { BaseButton, BaseToolTip } from 'xrk-components';

import { BaseSvg } from '@/components/base/base-svg/index';
import { useCopy } from '@/hooks/use-copy';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-center-edit-header',
  props: {
    sceneName: {},
    projectName: {},
    projectCode: {},
    showIndex: { type: Boolean, default: true }
  },
  setup(__props: any) {



const router = useRouter();

const onGoBack = async () => {
  window.sessionStorage.removeItem('projectDetail');
  router.push({
    name: 'project-center-list'
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showIndex)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_unref(BaseSvg), {
              iconClass: "shouye",
              style: {"font-size":"19px","margin-right":"10px"}
            }),
            _createElementVNode("span", { onClick: onGoBack }, "项目中心")
          ]),
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.sceneName && _ctx.sceneName !== '-')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.sceneName), 1),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(_unref(BaseToolTip), {
          style: {"overflow":"hidden","text-overflow":"ellipsis","-webkit-box-orient":"vertical","display":"-webkit-box","line-clamp":"1","white-space":"initial","word-break":"break-all"},
          "over-show": "",
          content: _ctx.projectName
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.projectName), 1)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      (_ctx.projectCode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createTextVNode(" （项目编码：" + _toDisplayString(_ctx.projectCode) + " ", 1),
            _createVNode(_unref(BaseButton), {
              style: {"margin-right":"-10px"},
              type: "primary2",
              link: "",
              icon: _unref(CopyDocument),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(useCopy)(_ctx.projectCode)))
            }, null, 8, ["icon"]),
            _createTextVNode(" ） ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})